import React from "react";
import Marquee from "react-fast-marquee";
import { MARQUEE_WORDS } from "@/data/content";

const Dot = () => (
  <span className="mx-6 md:mx-10 inline-block w-2 h-2 rounded-full bg-gold/70 align-middle" />
);

const EditorialMarquee = () => {
  return (
    <section data-testid="marquee-section" className="relative py-10 md:py-14 border-y border-white/[0.06] bg-ink-surface/30">
      <Marquee speed={40} gradient gradientColor="#050505" gradientWidth={120} autoFill>
        {MARQUEE_WORDS.map((w, i) => (
          <span key={i} className="inline-flex items-center">
            <span className="font-serif italic text-3xl md:text-5xl lg:text-6xl text-white/90 tracking-tight">
              {w}
            </span>
            <Dot />
          </span>
        ))}
      </Marquee>
    </section>
  );
};

export default EditorialMarquee;
